import IRestaurantCategory from 'interfaces/IRestaurantCategory';
import RestService from './RestService';

export default class RestaurantCategoryService extends RestService<IRestaurantCategory> {
  constructor() {
    super('restaurant-categories');
  }
}
